import request from '@/utils/request'
import  qs from 'qs'

export function delFeedback(data) {//删除
    return request({
        url: '/feedback/del/'+data.id,
        method: 'post',
        data
    })
}

export function getFeedBackList(data) {//创建
    return request({
        url: '/backend/toilet/image/detail/'+data.id,
        method: 'post',
    })
}
export function getFeedBackListByToilet(data) {//创建
    return request({
        url: '/backend/feedback/detail/'+data.id,
        method: 'post',
    })
}

export function changeToiletImageStatus(data) {//创建
    return request({
        url: '/backend/toilet/image/enable',
        method: 'post',
        data
    })
}

